<template>
  <div>
    <vx-card title="Company" class="mb-5">
      <vs-select
        class="w-full mb-1"
        v-model="company">
        <vs-select-item
          class="vs-input-shadow-drop vs-select-no-border"
          v-for="({ text, value }, index) in companies"
          :key="`${value}-${index}`"
          :value="value"
          :text="text"
        />
      </vs-select>
    </vx-card>
    <vs-row style="justify-content: space-between">
      <vs-col
        v-for="({ title, count }, index) in orderData" :key="index"
        class="p-1 mb-5"
        vs-lg="4"
        vs-sm="12"
      >
        <vx-card style="text-align: center">
          <div style="margin-bottom: 18px;">
            <h4>{{ title }}</h4>
          </div>
          <div style="font-size: 20px;">
            {{ count }}
          </div>
        </vx-card>
      </vs-col>
    </vs-row>
    <vs-button
      v-if="orderData[1].count"
      @click="createInvc"
      class="my-4"
    >
      Bill Orders
    </vs-button>
    <vs-table :data="invoices">
      <template slot="thead">
        <vs-th>Invoice #</vs-th>
        <vs-th>Subtotal</vs-th>
        <vs-th>Tax</vs-th>
        <vs-th>Total</vs-th>
      </template>
      <template slot-scope="{data}">
        <tbody :key="index" class="cursor-pointer" v-for="(invc, index) in data" @click="showInvc(data[index].invcNumber)">
          <vs-tr>
            <vs-td :data="invc">{{ invc.invcNumber }}</vs-td>
            <vs-td :data="invc">${{ invc.subtotal }}</vs-td>
            <vs-td :data="invc">${{ invc.tax }}</vs-td>
            <vs-td :data="invc">${{ invc.total }}</vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <vs-pagination
      :total="invcPagination.pages"
      :max="5"
      :value="invcPagination.page"
      @input="(val) => { fetchData(val) }"
      style="
        width: 100%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin: 34px 0 0 0;
      "
    />
    <partner-invc-dialog
      :active.sync="invcDialog.active"
      :source.sync="invcDialog.source"
      :create.sync="invcDialog.create"
      :invcNumber.sync="invcDialog.invcNumber"
      :refreshInvcList="fetchData"
    />
  </div>
</template>

<script>
import http from '@/http/api';
import PartnerInvcDialog from "@/views/partner-invoices/compenents/PartnerInvcDialog";

export default {
  components: {PartnerInvcDialog},
  comments: ['PartnerInvcDialog'],
  created() {
    this.companies = [
      { text: 'Younify', value: 'younify' }
    ]
  },
  data: () => {
    return {
      company: 'younify',
      orderData: [
        { title: 'Pending Orders', count: 0 },
        { title: 'Unbilled Orders', count: 0 },
        { title: 'Billed Orders', count: 0 }
      ],
      invoices:[],
      invcPagination: {
        page: 1,
        pages: 0
      },
      invcDialog: {
        active: false,
        source: null,
        invcNumber: null,
      },
    }
  },
  mounted() {
    this.fetchData()
  },
  watch: {
    company: { handler() { this.fetchData() } },
  },
  methods: {
    async fetchData(page = 1) {
      this.$vs.loading();

      await Promise.all([
        http.getPartnerOrderStatuses(this.company).then(data => {
          if (!data) return;
          this.orderData[0].count = data.pending
          this.orderData[1].count = data.unBilled
          this.orderData[2].count = data.billed
        }),
        http.getPartnerInvcs(this.company, {page}).then(({ data, pagination }) => {
          this.invoices = data
          this.invcPagination.page = pagination.page
          this.invcPagination.pages = pagination.pages
        })
      ])

      this.$vs.loading.close();
    },
    showInvc(invcNumber) {
      this.invcDialog = {
        active: true,
        source: this.company,
        invcNumber: invcNumber,
        create: false
      }
    },
    createInvc() {
      this.invcDialog = {
        active: true,
        source: this.company,
        invcNumber: null,
        create: true
      }
    }
  }
}
</script>
